import { useEffect, useRef, useState } from 'react';

// TODO: replace with real loading state once regeneration is implemented
export function useRegenerateLoadingState({ durationMs = 2000 }: { durationMs?: number } = {}) {
	const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		return function cleanup() {
			if (timeoutRef.current) {
				clearTimeout(timeoutRef.current);
			}
		};
	}, []);

	function startLoading() {
		setIsLoading(true);
		if (timeoutRef.current) {
			clearTimeout(timeoutRef.current);
		}
		timeoutRef.current = setTimeout(() => {
			setIsLoading(false);
		}, durationMs);
	}

	return [startLoading, isLoading] as const;
}
